import { LucideProps } from 'lucide-react';

export const YoutubeIcon = ({
  size = 20,
  color = 'currentColor',
  className,
  ...props
}: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 28 20"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M21.1639 0.00352512C24.6595 -0.111809 27.5947 2.61707 27.7314 6.11456C27.7319 6.12714 27.7321 6.13976 27.7321 6.15235V13.8477C27.7321 13.8602 27.7319 13.8728 27.7314 13.8854C27.5947 17.3833 24.659 20.1123 21.163 19.9964H6.56911C3.07318 20.1123 0.13735 17.3833 0.000747908 13.8854C0.000256904 13.8728 1.28003e-07 13.8602 0 13.8477V6.15235C0 6.13977 0.000257216 6.12717 0.000747908 6.1146C0.137332 2.61708 3.07264 -0.111809 6.56817 0.00352512H21.1639ZM25.7973 6.17365C25.6935 3.74239 23.6461 1.84909 21.2122 1.93769C21.2005 1.93812 21.1887 1.93832 21.177 1.93832H6.5551C6.54337 1.93832 6.53163 1.93812 6.51991 1.93769C4.08599 1.84909 2.0386 3.7424 1.9348 6.17365V13.8263C2.0386 16.2577 4.08598 18.1509 6.51991 18.0623L6.5375 18.0618C6.54337 18.0617 6.54923 18.0616 6.5551 18.0616H21.177L21.1946 18.0618C21.2005 18.0619 21.2063 18.0621 21.2122 18.0623C23.6462 18.1509 25.6935 16.2577 25.7973 13.8263V6.17365Z"
      fill={color}
    />
    <path
      d="M12.6882 7.15637C12.5978 7.095 12.45 7.07546 12.3144 7.1272C12.2872 7.13757 12.2676 7.14844 12.2541 7.15724V12.843C12.2675 12.8518 12.287 12.8628 12.3143 12.8732C12.4436 12.9226 12.5856 12.9069 12.678 12.8502L16.6842 9.87179L12.6882 7.15637ZM18.7031 9.86974C18.7031 10.4983 18.3803 11.0813 17.851 11.4153L13.809 14.4203C13.7978 14.4286 13.7864 14.4367 13.7749 14.4445C13.0929 14.9071 12.2685 14.9269 11.6238 14.6806C10.9871 14.4374 10.3193 13.8333 10.3193 12.9009V7.09658C10.3193 6.16387 10.9902 5.56152 11.6248 5.31947C12.2685 5.07391 13.0932 5.09245 13.7755 5.55605H13.7756L17.8313 8.31205C18.3721 8.64388 18.7031 9.23331 18.7031 9.86974Z"
      fill={color}
    />
  </svg>
);
